import Vue from 'vue';

export const EVENT_SHOW_CONFIRM = 'EVENT_SHOW_CONFIRM';
export const EVENT_SHOW_ALERT = 'EVENT_SHOW_ALERT';
export const EVENT_SHOW_ERROR_PAGE = 'EVENT_SHOW_ERROR_PAGE';
export const EVENT_CLOSE_MODAL = 'EVENT_CLOSE_MODAL';
export const EVENT_SHOW_MODAL = 'EVENT_SHOW_MODAL';
export const EVENT_SYNC_SIGN_DATA = 'EVENT_SYNC_SIGN_DATA';

export const $eventBus = new Vue();

Object.defineProperties(Vue.prototype, {
    $eventBus: {
        get: function () {
            return $eventBus;
        }
    }
});
